import { render, staticRenderFns } from "./AddPatient.vue?vue&type=template&id=b41f18ba&scoped=true&"
import script from "./AddPatient.vue?vue&type=script&lang=js&"
export * from "./AddPatient.vue?vue&type=script&lang=js&"
import style0 from "./AddPatient.vue?vue&type=style&index=0&id=b41f18ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b41f18ba",
  null
  
)

export default component.exports